import React, { Component } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CustomButton from '../customButton/customButton';
import DialogStyles from '../../assets/css/dialog.Styles';
import { CustomDialogProps } from './customDialogProps';
import { VALIDATION_ERROR_REQUIRED_MESSAGE } from '../../constants/actions';

class CustomDialog<T> extends Component<CustomDialogProps<T>, { codeError: boolean }> {
  constructor(props: CustomDialogProps<T>) {
    super(props);
    this.state = {
      codeError: false,
    };
  }

  handleCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { setCode } = this.props;
    if (setCode) {
      setCode(event.target.value);
      this.setState({ codeError: false });
    }
  };

  handleConfirm = () => {
    const { onConfirm, code, isVerificationDialog } = this.props;
    if (isVerificationDialog && (!code || code.trim() === '')) {
      this.setState({ codeError: true });
      return;
    }
    if (onConfirm) {
      onConfirm();
    }
  };

  render() {
    const {
      open,
      onClose,
      text,
      text2,
      title,
      buttonTitle,
      icon,
      isVerificationDialog,
      code,
    } = this.props;
    const { codeError } = this.state;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '400px',
            width: '100%',
            margin: 'auto',
            padding: '16px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <DialogTitle
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            ...(isVerificationDialog
              ? DialogStyles.dialogTitle
              : DialogStyles.dialogErrorTitle),
          }}
        >
          <span>{title}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={DialogStyles.dialogContentText}>{text}</DialogContentText>
          {text2 && (
            <DialogContentText style={DialogStyles.dialogContentText2}>{text2}</DialogContentText>
          )}
          {isVerificationDialog && (
            <TextField
              fullWidth
              margin="normal"
              label="Code"
              value={code || ''}
              onChange={this.handleCodeChange}
              error={codeError}
              helperText={codeError ? VALIDATION_ERROR_REQUIRED_MESSAGE : ''}
            />
          )}
        </DialogContent>
        <DialogActions style={DialogStyles.dialogActions}>
          <CustomButton
            style={DialogStyles.cancelDialog}
            startIcon={<CancelIcon />}
            onClick={onClose}
          >
            Cancel
          </CustomButton>
          <CustomButton
            style={
              isVerificationDialog
                ? DialogStyles.confirmDialog
                : DialogStyles.deleteDialog
            }
            startIcon={icon}
            onClick={this.handleConfirm}
          >
            {buttonTitle}
          </CustomButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CustomDialog;
